import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
  /* Better font rendering */
  html {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    box-sizing: border-box;
    overflow-y: scroll; /* Always show scrollbar to prevent layout shifts */
  }
  
  *, *:before, *:after {
    box-sizing: inherit;
  }
  
  body {
    margin: 0;
    padding: 0;
    font-family: 'Inter', sans-serif;
    color: #333;
    background-color: #fafafa;
    line-height: 1.5;
  }
  
  /* Typography */
  h1, h2, h3, h4, h5, h6 {
    font-family: 'Lucida Bright', 'Lucida Serif', Georgia, serif;
    font-weight: normal;
    color: #333;
    margin-top: 0;
  }
  
  h1 {
    font-size: 2.4rem;
    margin-bottom: 1.2rem;
  }
  
  h2 {
    font-size: 1.8rem;
    margin-bottom: 1rem;
  }
  
  h3 {
    font-size: 1.4rem;
    margin-bottom: 0.8rem;
  }
  
  p {
    margin-bottom: 1.5rem;
    font-size: 1rem;
    line-height: 1.6;
  }
  
  a {
    color: #333;
    text-decoration: none;
    transition: color 0.2s ease;
    
    &:hover {
      color: #000;
    }
  }
  
  /* Forms */
  input, textarea, select, button {
    font-family: 'Inter', sans-serif;
    font-size: 1rem;
  }
  
  button {
    cursor: pointer;
  }
  
  /* Transitions */
  a, button {
    transition: all 0.2s ease;
  }
  
  /* Scrollbar styling */
  ::-webkit-scrollbar {
    width: 10px;
  }
  
  ::-webkit-scrollbar-track {
    background: #f1f1f1;
  }
  
  ::-webkit-scrollbar-thumb {
    background: #ccc;
    border-radius: 5px;
  }
  
  ::-webkit-scrollbar-thumb:hover {
    background: #999;
  }
  
  /* Selection */
  ::selection {
    background-color: rgba(0, 0, 0, 0.1);
  }
`;

export default GlobalStyles; 